import $ from 'jquery';

function highlightRequired($elem, has_data) {

  if (has_data) {
    $elem.closest('.form-group')

      .classList.remove('has-error');
  } else {
    $elem.closest('.form-group')
      .classList.add('has-error');
  }
}

class Claim {

  constructor() {
  }

  init() {
    this.form = document.getElementById('claim_form');

    if (!this.form) return;

    this.policy_type = this.form.querySelector('select[name="policy_type"]');
    this.loss_cause = this.form.querySelector('select[name="loss_cause"]');
    this.client = this.form.querySelector('select[name="client_id"]');
    this.is_cat = this.form.querySelectorAll('input[name="is_cat"]');
    this.storm = this.form.querySelector('select[name="storm_id"]');
    this.stormGroup = this.storm.closest('.form-group');
    this.ulae_claim_type = this.form.querySelector('select[name="ulae_claim_type"]');
    this.claimant = this.form.querySelector('input[name="claimant"]');
    this.claimant_first = this.form.querySelector('input[name="claimant_first_name"]');
    this.claimant_last = this.form.querySelector('input[name="claimant_last_name"]');
    this.aspen_company = this.form.querySelector('select[name="aspen_company"]');
    this.prior_claim_number = this.form.querySelector('#prior_claim_number');
    this.existing_claim = this.form.querySelector('input[name="existing_claim"]');
    this.deductible = this.form.querySelector('input[name="deductible"]');
    this.tiv = this.form.querySelector('input[name="tiv"]');

    this.setDeductibleFields();
    this.setPolicyTypeFields();
    this.setClaimantField();
    this.setAspenCompanyField();
    this.setTrisuraFields();
    this.setDependentFields();
    if (this.prior_claim_number.value && !document.querySelector('.alert.alert-danger')) {
      this.existing_claim.setAttribute('checked', true);
    }
    this.setAvondaleFields();
  }

  setupEvents() {

    if (!this.form) return;

    let _this = this;

    this.policy_type.addEventListener('change', function () {
      _this.setPolicyTypeFields();
      _this.setDependentFields();
    });

    this.client.addEventListener('change', function () {
      _this.setDependentFields();
      _this.setClientDependentFields();
    });

    // Temporary fix for 'change' event listener on Chosen <select>.
    $(this.ulae_claim_type).on('change', function(e) {
      _this.setDependentFields();
    });

    this.is_cat.forEach(node => {
      node.addEventListener('change', function (event) {
        if (event.target.value == 1) {
          _this.storm.disabled = false;
          //TODO slideDown fast animation.
          _this.stormGroup.classList.remove('d-none');
        } else {
          _this.storm.disabled = true;
          //TODO slideUp fast animation.
          _this.stormGroup.classList.add('d-none');
        }
      });
    });

    this.form.querySelector('#copy_insured_address').addEventListener('click', function (event) {
      event.preventDefault();

      _this.form.querySelector('#loss_address').value = _this.form.querySelector('#insured_address').value;
      _this.form.querySelector('#loss_city').value = _this.form.querySelector('#insured_city').value;
      _this.form.querySelector('#loss_state').value = _this.form.querySelector('#insured_state').value;
      _this.form.querySelector('#loss_zip').value = _this.form.querySelector('#insured_zip').value;
    });

    $(this.form.querySelector('[name="policy_range_start"]')).datepicker().on('changeDate', function (e) {

      let $endPicker = $(_this.form.querySelector('[name="policy_range_end"]'));
      let end = $endPicker.datepicker('getDate');

      if (!end) {
        end = e.date;
        end.setFullYear(end.getFullYear() + 1);
        $endPicker.datepicker('update', end);
      }
    });

    this.form.querySelector('input#claimant_insured').addEventListener('click', function (event) {
      if (event.target.checked) {
        let insured = (_this.form.querySelector("input[name='business_name']").value ?? '').trim();
        if (_this.form.querySelector("input[name='business_name']").hasAttribute("disabled")) {
          let firstName = (_this.form.querySelector("input[name='insured_first_name']").value ?? '').trim();
          let lastName = (_this.form.querySelector("input[name='insured_last_name']").value ?? '').trim();
          insured = firstName + " " + lastName;
        }
        _this.claimant.value = insured;
        _this.claimant_first.value = insured.split(' ')[0];
        _this.claimant_last.value = insured.split(' ')[1];
      }
    });
    this.form.querySelector('input#claimant_tbd').addEventListener('click', function (event) {
      if (event.target.checked) {
        _this.claimant.value = 'tbd';
        _this.claimant_first.value = '';
        _this.claimant_last.value = '';
      }
    });
    this.form.querySelector('a#clear_claimant_type').addEventListener('click', function (event) {
      event.preventDefault();
      _this.claimant.value = '';
      _this.claimant_first.value = '';
      _this.claimant_last.value = '';
      _this.form.querySelectorAll('input[name="claimant_type"]').forEach(checkbox => {
        checkbox.checked = false;
      });
      return false;
    });
    this.existing_claim.addEventListener('change', function () {
      _this.setAvondaleFields();
    });
    this.tiv.addEventListener('change', function () {
      _this.setTrisuraFields();
    });
    this.deductible.addEventListener('change', function () {
      _this.setTrisuraFields();
    });

    this.form.querySelectorAll('input[name="deductible_type"]').forEach(radio => {
      radio.addEventListener('change', function () {
        _this.setTrisuraFields();
      });
    });
  }

  setPolicyTypeFields() {
    let isCommercial = Array.from(this.policy_type.querySelectorAll('option'))
      .filter(option => option.selected)[0].getAttribute('data-is-commercial');

    let insuredNameNodes = this.form.querySelectorAll(['input[name="insured_first_name"]', 'input[name="insured_last_name"]']);
    let bn = this.form.querySelector('input[name="business_name"]');
    if (isCommercial) {
      insuredNameNodes.forEach(node => {
        node.disabled = true;
        node.closest('.form-group').classList.add('d-none');
      });
      bn.disabled = false;
      bn.value = bn.getAttribute('data-insured');
      bn.closest('.form-group').classList.remove('d-none');
    } else {
      insuredNameNodes.forEach(node => {
        node.disabled = false;
        node.closest('.form-group').classList.remove('d-none');
      });
      bn.disabled = true;
      bn.value = '';
      bn.closest('.form-group').classList.add('d-none');
    }
  }

  setDependentFields() {

    this.form.querySelectorAll('[data-dependency]').forEach(node => {
      let d = node;
      let dependencies = JSON.parse(d.getAttribute('data-dependency') ?? '[]');
      let visible = true;
      for (let dependency of dependencies) {
        let value = document.getElementById(dependency.id).value;
        if (Array.isArray(dependency.value)) {
          visible &= dependency.value.includes(value === "" ? value : parseInt(value));
        } else {
          visible &= parseInt(value) === parseInt(dependency.value);
        }
      }

      d.querySelectorAll('.form-control').forEach(node => {
        node.disabled = !visible;
      });
      if (visible) {
        d.classList.remove('d-none');
        d.querySelectorAll('select.form-control').forEach(node => {
          $(node).chosen('destroy').chosen();
        });
      } else {
        d.classList.add('d-none');
      }
    });
  }

  setDeductibleFields() {
    let deductibleType = this.form.querySelector('input[name="deductible_type"]:checked');
    let isTpa = this.client.options[this.client.selectedIndex].dataset.tpa === '1';
    let clientCode = this.client.options[this.client.selectedIndex].dataset.code;
    let hasDeductible = isTpa;
    let isAvondale = ['AVT', 'AVS'].includes(clientCode);

    if (!deductibleType || isAvondale) {
      this.form.querySelector('#deductible_type_pct').checked = false;
      this.form.querySelector('#deductible_type_pct').closest('label').classList.remove('active');
      this.form.querySelector('#deductible_type_usd').checked = true;
      this.form.querySelector('#deductible_type_usd').closest('label').classList.add('active');
    }

    this.deductible.closest('.form-group').classList.toggle('d-none', !hasDeductible);
    this.deductible.closest('.form-group').querySelector('.input-group-append').classList.toggle('d-none', hasDeductible && isAvondale);
  }

  setTrisuraFields() {
    let deductibleTypePct = this.form.querySelector('#deductible_type_pct');
    let assignedDate = this.form.querySelector('input[name="assigned_date"]');
    let clientCode = this.client.options[this.client.selectedIndex].dataset.code;
    let trisuraCodes = ['TFL', 'TLR', 'TRP', 'TRL'];
    let fieldsToHide = ['#occurrence_id', '#location', '#tiv', '#deductible_basis'];
    let isTrisura = trisuraCodes.includes(clientCode);

    let tivRequired = isTrisura && deductibleTypePct.checked && this.deductible.value && !this.tiv.value;

    this.tiv.toggleAttribute('required', tivRequired);
    this.tiv.closest('.form-group').classList.toggle('required', tivRequired);

    fieldsToHide.forEach((field) => {
      this.form.querySelector(field).closest('.form-group').classList.toggle('d-none', !isTrisura);
    });

    assignedDate.toggleAttribute('required', isTrisura);
  }

  setClientDependentFields() {
    let isTpa = Array.from(this.client.querySelectorAll('option')).filter(node => node.selected)[0].getAttribute('data-tpa') === '1';
    let policyTypeLabel = this.policy_type.getAttribute(isTpa ? 'data-tpa-label' : 'data-label');

    this.policy_type
      .closest('.form-group')
      .querySelector('label')
      .innerText = policyTypeLabel;

    this.policy_type
      .querySelector('option[value=""]')
      .innerText = 'Select a ' + policyTypeLabel.toLowerCase() + '...';

    if (isTpa) {
      this.policy_type.querySelectorAll('option[data-tpa-only="1"]').forEach(option => {
        option.classList.remove('d-none');
      });
      this.policy_type.querySelectorAll('option:not([data-tpa-only="1"]):not([value=""])').forEach(option => {
        option.classList.add('d-none');
      });
    } else {
      this.policy_type.querySelectorAll('option[data-tpa-only="1"]').forEach(option => {
        option.classList.add('d-none');
      });
      this.policy_type.querySelectorAll('option:not([data-tpa-only="1"])').forEach(option => {
        option.classList.remove('d-none');
      });
    }

    $(this.policy_type).trigger('chosen:updated');
    $(this.ulae_claim_type).trigger('chosen:updated');

    this.setDeductibleFields();
    this.setLossCauseField();
    this.setClaimantField();
    this.setAspenCompanyField();
    this.setTrisuraFields();
    this.setAvondaleFields();
  }

  setClaimantField() {
    let isTpa = Array.from(this.client.querySelectorAll('option'))
      .filter(option => option.selected)[0].getAttribute('data-tpa') == 1;

    const claimantOptions = this.form.querySelector('#claimant-options');

    if (isTpa) {
      this.claimant.setAttribute('required', 'true');
      claimantOptions.classList.remove('d-none');
    } else {
      this.claimant.removeAttribute('required');
      claimantOptions.classList.add('d-none');
    }
  }

  setLossCauseField() {
    const clientCode = this.client.options[this.client.selectedIndex].dataset.code;
    const isAvondale = clientCode === 'AVT';

    if (isAvondale) {
      this.loss_cause.querySelectorAll('option[data-avondale-only="1"]').forEach(option => {
        option.classList.remove('d-none');
      });
      this.loss_cause.querySelectorAll('option:not([data-avondale-only="1"]):not([data-for-all="1"]):not([value=""])').forEach(option => {
        option.classList.add('d-none');
      });
    } else {
      this.loss_cause.querySelectorAll('option[data-avondale-only="1"]').forEach(option => {
        option.classList.add('d-none');
      });
      this.loss_cause.querySelectorAll('option:not([data-avondale-only="1"])').forEach(option => {
        option.classList.remove('d-none');
      });
    }
  }

  setUlaeClaimTypeField() {
    let clientId = parseInt(Array.from(this.client.querySelectorAll('option'))
      .filter(option => option.selected)[0].value);

    this.ulae_claim_type.querySelectorAll('option').forEach(option => {
      let clients = JSON.parse(option.getAttribute('data-clients'));

      if (Array.isArray(clients)) {

        if (clients.includes(clientId)) {
          option.classList.remove('d-none');
        }
        else {
          option.classList.add('d-none');
        }

      }
    });

    $(this.ulae_claim_type).trigger('chosen:updated');
  }

  setAspenCompanyField() {
    let clientId = parseInt(Array.from(this.client.querySelectorAll('option'))
      .filter(option => option.selected)[0].value);

    let aspen_company_options =  JSON.parse(this.aspen_company.getAttribute('data-aspen-company-options'));
    let allowedClients = Object.keys(aspen_company_options);
    let aspen_company_value = this.aspen_company.getAttribute('data-value');

    if (allowedClients.includes(clientId.toString())) {
      // Remove options.
      this.aspen_company.querySelectorAll('option').forEach(o => o.remove());

      // Add new options.
      let options = aspen_company_options[clientId.toString()];
      for (const [key, value] of Object.entries(options)) {
        let newOption = new Option(value, key);
        newOption.selected =  (value === aspen_company_value);
        this.aspen_company.add(newOption, undefined);
      }

      // Show "Company" field.
      this.aspen_company.classList.remove('d-none');
      this.aspen_company.parentNode.parentNode.classList.remove('d-none');
    }
    else {
      // Hide "Company" field.
      this.aspen_company.classList.add('d-none');
      this.aspen_company.parentNode.parentNode.classList.add('d-none');
    }
  }

  setAvondaleFields() {
    const priorClaimNumberParent = this.prior_claim_number.closest('.form-group');
    const clientCode = this.client.options[this.client.selectedIndex].dataset.code;
    const isAvondale = clientCode === 'AVT';

    if (isAvondale && this.existing_claim.checked) {
      this.prior_claim_number.setAttribute('required', 'true');
      priorClaimNumberParent.classList.add('required');
      priorClaimNumberParent.classList.remove('d-none');
    } else {
      this.prior_claim_number.removeAttribute('required');
      priorClaimNumberParent.classList.remove('required');
      priorClaimNumberParent.classList.add('d-none');
    }
  }

  load() {
    this.init();
    this.setupEvents();
  }
}

export default new Claim();
